import styled, { css } from 'styled-components';

const GDTBannerStyled = styled.div.attrs({
  className: 'gdt-banner',
})`
  ${({ theme, backgroundColor, button, sticky }) => {
    const { colors, media } = theme;

    return css`
      transition: transform 0.3s ease-out;
      z-index: 19;
      background-color: ${backgroundColor === 'lightBlue' ? colors.tertiary.lightBlue : backgroundColor};
      padding: 16px 16px 16px 16px;
      margin: 40px 0;
      display: flex;
      align-items: center;
      justify-content: center;

      ${(sticky === 'top' || sticky === 'bottom') &&
      css`
        position: -webkit-sticky; /* Safari */
        position: sticky;
        ${sticky === 'top' &&
        css`
          top: 24px;
        `}
        ${sticky === 'bottom' &&
        css`
          bottom: 24px;
        `}
      `}

      ${media.tablet.up} {
        padding: 16px 24px 16px 40px;
        justify-content: space-between;
      }

      .gdt-banner {
        &__mobile-button {
          justify-content: space-between;
          border: none;
          background-color: ${backgroundColor === 'lightBlue' ? colors.tertiary.lightBlue : backgroundColor};
          cursor: pointer;
          text-decoration: underline;
        }

        &__text-block {
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: ${colors.primary.black};
        }
        &__text--title {
          font-weight: bold;
          padding-right: 24px;
          font-size: 1.125rem;
          line-height: 22px;
        }
        &__text--subtitle {
          font-weight: normal;
          padding-right: 150px;
          font-size: 1rem;
          line-height: 20px;
        }
        &__text--mobile-title {
          font-weight: normal;
          text-decoration: underline;
          padding-left: 50px;
          font-size: 0.875rem;
          line-height: 18px;
        }
        &__button {
          background-color: ${button?.backgroundColor || colors.primary.black};
          color: ${button?.textColor || colors.primary.white};
          border-color: ${colors.primary.black};
          padding-top: 16px;
          padding-bottom: 16px;
          padding-left: 24px;
          padding-right: 24px;
          font-size: 1.125rem;
          line-height: 24px;
        }
        &__close {
          path {
            fill: ${colors.primary.black};
          }

          color: ${colors.primary.black};
          cursor: pointer;
          height: 12px;
          min-width: 80px;

          ${media.tablet.up} {
            height: 16px;
          }
        }
      }
    `;
  }}
`;

export default GDTBannerStyled;
